module.exports = __webpack_public_path__ + "static/img/lipa-na-mpesa.264e1e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/lipa-na-mpesa.jpg
// module id = PY7d
// module chunks = 1